import { render } from "./ProfileTitleHeader.vue?vue&type=template&id=bcc50da4&scoped=true"
import script from "./ProfileTitleHeader.vue?vue&type=script&lang=js"
export * from "./ProfileTitleHeader.vue?vue&type=script&lang=js"

import "./ProfileTitleHeader.vue?vue&type=style&index=0&id=bcc50da4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcc50da4"]])

export default __exports__